export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4592.19b7e951.jpg";